import styled from "styled-components";

export const FanWrapper = styled.div``